import { jwtDecode } from "jwt-decode";

const useDecodeToken = () => {
  const decryptToken = (token) => {
    return token ? jwtDecode(token) : false;
  };

  return {
    decryptToken,
  };
};

export default useDecodeToken;
